import { useState } from "react";
import classNames from "classnames";
import Bugsnag from "@bugsnag/js";
import exclamationCircleOrange from '../../assets/images/exclamation-circle-orange.png';
import styles from './RequestAction.module.css';
import { updateFundraiserRequestApi } from "../../api/fundraisers";
import Button from "../Button";

const RequestAction = (props) => {
	const [approveOrRejectInProgress, setApproveOrRejectInProgress] = useState(false);

	const updateRequest = async (status) => {
		setApproveOrRejectInProgress(true);
		const updateRequestResponse = await updateFundraiserRequestApi(props.fundraiserId, status);
		let body;
        try{
            body = await updateRequestResponse.json();
        }
        catch(e){}
        if(updateRequestResponse && updateRequestResponse.ok){
			props.setRequestStatus(status);
			props.setShowRequestAction(false);
        }
		else{
			Bugsnag.notify(body?.error ? body.error : 'Fundraiser request update failed');
			alert('Something went wrong. Request was not updated');
			setApproveOrRejectInProgress(false);
		}
	};

	return (
		<div id="request-action" className={classNames(styles.container, props.className)}>
			<div className={styles.topSection}>
				<img className={styles.exclamationCircleOrange} src={exclamationCircleOrange} alt="Exclamation"/>
				The organizer is requesting a direct payout
			</div>
			<div className={styles.buttons}>
				<Button className={styles.rejectButton} text="Reject" onClick={() => updateRequest('rejected')} disabled={approveOrRejectInProgress}/>
				<Button className={styles.approveButton} text="Approve" dark={true} onClick={() => updateRequest('approved')} disabled={approveOrRejectInProgress}/>
			</div>
		</div>
	)
};

export default RequestAction;